import React, { useState, ReactNode, useEffect } from "react";

interface RadioButtonWithSVGProps {
  option: string;
  offSVG?: ReactNode;
  onSVG?: ReactNode;
  selectedOption?: string;
  value: string;
  onSelect?: (option: string, name?: string) => void;
  selectedClassName?: string;
  unselectedClassName?: string;
  className?: string;
  name?: string;
}

const RadioButtonWithSVG: React.FC<RadioButtonWithSVGProps> = ({
  option,
  offSVG,
  onSVG,
  selectedOption,
  value,
  onSelect,
  selectedClassName,
  unselectedClassName,
  className,
  name,
}) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(value === selectedOption);
  }, [value, selectedOption]);

  const handleRadioChange = () => {
    onSelect?.(value, name);
  };

  return (
    <label className="cursor-pointer">
      <input
        type="radio"
        className="peer sr-only"
        name="pricing"
        checked={value === selectedOption}
        onChange={handleRadioChange}
        value={value}
      />
      <div
        className={`rounded-md  transition-all hover:shadow ${
          isSelected ? selectedClassName : unselectedClassName
        } ${className || ""}`}
      >
        <div className="flex flex-col gap-1">
          <div className="flex items-center ">
            <div>{value === selectedOption ? onSVG : offSVG}</div>
            <p className="text-sm font-semibold capitalize  mb-1 px-1">
              {option}
            </p>
          </div>
        </div>
      </div>
    </label>
  );
};

export default RadioButtonWithSVG;
